import { useMutation, useQueryCache } from 'react-query';
import { EventCategoryRestrictionAPI } from 'api/admin/eventCategoryRestriction';
import { COMPETITIONS } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useCreateEventCategoryRestriction() {
  const queryCache = useQueryCache();

  return useMutation(EventCategoryRestrictionAPI.add, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      dispatchToast({ message, type: 'success' });
      queryCache.invalidateQueries(COMPETITIONS);
      onSuccess();
    },
  });
}
